<template>
  <el-form-item
    :label="attrOption.label"
    :prop="attrOption.prop"
  >
    <el-select
      v-model="customerNameId"
      v-bind="attrOption"
    >
      <el-option
        v-for="item in attrOption.options.list"
        :key="'option' + item[attrOption.options.value]"
        :label="item[attrOption.options.label]"
        :value="item[attrOption.options.value]"
      >
        <CustomerNameOptionItem :data="item" />
      </el-option>
    </el-select>
    <div
      class="customerTips"
      @click="attrOption.events.tipsClick"
      >找不到客户？点击新增</div
    >
  </el-form-item>
</template>

<script>
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export default {
  components: {
    CustomerNameOptionItem,
  },
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      defaultOption: { remote: true, filterable: true, clearable: true },
      attrOption: {},
    }
  },
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
  },
  watch: {
    $attrs: {
      handler(val) {
        this.attrOption = {
          ...this.defaultOption,
          ...val,
        }
      },
      deep: true,
    },
  },
  computed: {
    customerNameId: {
      set(val) {
        this.$emit('change', val)
      },
      get() {
        return this.model
      },
    },
  },
  created() {
    this.attrOption = {
      ...this.defaultOption,
      ...this.$attrs,
    }
  },
}
</script>

<style lang="scss" scoped>
.customerTips {
  color: #2e7eff;
  cursor: pointer;
}
</style>
